<div class="modal-content">

  <div class="modal-header">
    <h5 class="modal-title" id="modal-title-login">{{'Education level' | translate}}</h5>
    <button tabindex="10" type="button" class="close" (click)="activeModal.close(false)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="form-group">
      <label>{{'Region' | translate}}</label>
      <app-core-selector [type]="'checkbox'" [filterOptions]="regions" [selectorValue]="'id'" [selectorLabel]="'name'" [(ngModel)]="entity.regions"></app-core-selector>
    </div>

    <div class="form-group">
      <label>{{'Name' | translate}}</label>
      <input class="form-control" [(ngModel)]="entity.name" />
    </div>

    <div class="form-group">
      <label>{{'Level' | translate}}</label>
      <input type="number" class="form-control" [(ngModel)]="entity.level" />
    </div>

    <div class="form-group">
      <label>{{'School type' | translate}}</label>
      <select class="form-control" [(ngModel)]="entity.schoolType">
        <option [value]="schoolType.value" *ngFor="let schoolType of educationService.getSchoolTypeOptions()">
          {{schoolType.label | translate}}
        </option>
      </select>
    </div>

    <!-- profiles -->
    <div class="profiles mb-3">

      <h3>{{'Profiles' | translate}}</h3>

      <div class="profile-new mb-3">

        <p>{{'Add new' | translate}}</p>

        <div class="form-group">
          <label>{{'Code' | translate}}</label>
          <input [placeholder]="('Code' | translate) + '...'" class="form-control" [(ngModel)]="newProfile.code" />
        </div>

        <div class="form-group">
          <label>{{'Name' | translate}}</label>
          <input [placeholder]="('Name' | translate) + '...'" class="form-control" [(ngModel)]="newProfile.name" />
        </div>

        <div class="btn-toolbar">
          <button class="btn btn-primary ml-auto" (click)="addEducationProfile()">
            {{'Add' | translate}}
          </button>
        </div>

      </div>

      <table class="table table-striped table-bordered">
        <thead>
        <tr>
          <th>
            {{'Code' | translate}}
          </th>
          <th>
            {{'Name' | translate}}
          </th>
          <th>

          </th>
        </tr>
        </thead>
        <tbody *ngIf="entity.educationProfiles">
          <tr *ngFor="let profile of entity.educationProfiles; let key = index;">
            <td>
              {{profile.code}}
            </td>
            <td>
              {{profile.name}}
            </td>
            <td class="text-right">
              <button class="btn btn-danger" (click)="deleteProfile(key)">
                {{'Delete' | translate}}
              </button>
            </td>
          </tr>
        </tbody>
      </table>


    </div>

    <!-- phases -->
    <div class="phases">

      <h3>{{'Phases' | translate}}</h3>

      <div class="input-group mb-3">
        <input [placeholder]="('Phase' | translate) + '...'" class="form-control" [(ngModel)]="newPhase" />
        <div class="input-group-append">
          <button class="btn btn-primary" (click)="addPhase()">
            {{'Add' | translate}}
          </button>
        </div>
      </div>

      <table class="table table-striped table-bordered">
        <thead>
          <tr>
            <th>
              {{'Name' | translate}}
            </th>
            <th>

            </th>
          </tr>
        </thead>
        <tbody *ngIf="entity.phases">
        <tr *ngFor="let phase of entity.phases; let key = index;">
          <td>
            {{phase}}
          </td>
          <td class="text-right">
            <button class="btn btn-danger" (click)="deletePhase(key)">
              {{'Delete' | translate}}
            </button>
          </td>
        </tr>
        </tbody>
      </table>

    </div>

  </div>

  <div class="modal-footer">
    <div class="btn-toolbar flex-grow-1 justify-content-between">
      <button type="button" class="btn btn-secondary" (click)="activeModal.close(false)">{{'Cancel' | translate}}</button>
      <button type="button" class="btn btn-primary" (click)="Save()">{{'Save' | translate}}</button>
    </div>
  </div>
</div>

